import { BrowserRouter as Router } from "react-router-dom";
import { StaticRouter } from "react-router";
import AppContent from "./AppContent";

type AppRouterProps = {
  location?: string;
};

const AppRouter = ({ location }: AppRouterProps) => {
  if (typeof window === "undefined") {
    return (
      <StaticRouter location={location || "/"}>
        <AppContent />
      </StaticRouter>
    );
  }

  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default AppRouter;
